import React, { useMemo } from 'react';
import { describeActivity } from './workItemHistory';

const MESSAGE_KINDS = new Set(['message', 'nudge_sent', 'file_uploaded']);

/**
 * Human-readable activity / history feed (non-message timeline).
 */
const WorkItemActivityTab = ({ detail, resolveName, resolveProjectName, profileSub }) => {
  const rows = useMemo(() => {
    const list = (detail.timeline || []).filter((e) => !MESSAGE_KINDS.has(e.kind));
    return [...list].sort((a, b) => String(b.at || '').localeCompare(String(a.at || '')));
  }, [detail.timeline]);

  if (!rows.length) {
    return <p className='text-sm text-muted-foreground'>No activity yet</p>;
  }

  return (
    <ol className='relative max-h-80 overflow-y-auto space-y-0 border-l border-border ml-2 pl-4'>
      {rows.map((e) => {
        const copy = describeActivity(e, { resolveName, resolveProjectName, profileSub });
        return (
          <li key={e.id} className='relative pb-4 last:pb-0'>
            <span
              className='absolute -left-[1.3rem] top-1.5 h-2.5 w-2.5 rounded-full bg-primary ring-2 ring-card'
              aria-hidden
            />
            <p className='text-sm text-foreground leading-snug'>{copy.title}</p>
            {copy.detail ? (
              <p className='text-xs text-muted-foreground mt-0.5'>{copy.detail}</p>
            ) : null}
            <p className='text-xs text-muted-foreground mt-0.5'>{copy.when}</p>
          </li>
        );
      })}
    </ol>
  );
};

export default WorkItemActivityTab;
